import CustomModulesAPI from '../../api/customModules';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
  },
};

export const getters = {
  getModulesOnSidebar(_state) {
    return _state.records;
  },
};

export const actions = {
  get: async function getCustomModules({ commit }) {
    commit('SET_CUSTOM_MODULES_UI_FLAG', { isFetching: true });
    try {
      const response = await CustomModulesAPI.get();
      commit('SET_CUSTOM_MODULES', response.data.payload);
    } catch (error) {
      // Ignore error, the sidebar group simply stays empty
    } finally {
      commit('SET_CUSTOM_MODULES_UI_FLAG', { isFetching: false });
    }
  },
};

export const mutations = {
  SET_CUSTOM_MODULES(_state, records) {
    _state.records = records;
  },
  SET_CUSTOM_MODULES_UI_FLAG(_state, data) {
    _state.uiFlags = {
      ..._state.uiFlags,
      ...data,
    };
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
